<template>
    <div class="ion-page">
        <ion-header>
            <ion-toolbar>
                <ion-buttons v-slot: start>
                    <ion-back-button default-href="#" @click="navigatePreviousPage"></ion-back-button>
                    <ion-title>Manage Charger / <span class="ion-sub-title">{{chargerId}}</span> </ion-title>
                    <ion-buttons v-slot: end v-if="viewmode && rightToUpdate">
                    <ion-button @click="editCharger" class="hdrBtn">
                        EDIT
                    </ion-button>
                </ion-buttons>
                </ion-buttons>
                
            </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
            <ChargerDetail v-if="!viewmode" />
            <ChargerView v-if="viewmode" />
        </ion-content>
    </div>
</template>
<script>
import { defineComponent } from "vue";
import ChargerDetail from "@/components/admin/ChargerDetail.vue";
import ChargerView from "@/components/admin/ChargerView.vue";
import { AppUtils } from "@/util/app-utils"
import { IonBackButton, IonButtons, IonContent, IonHeader, IonTitle, IonToolbar } from '@ionic/vue';
export default defineComponent({
    name:  'chargerDetail',
    components: {
        ChargerDetail, ChargerView, IonHeader, IonToolbar, IonButtons, IonBackButton, IonTitle, IonButtons, IonContent
    },
    data() {
        return {
            rightToUpdate: false,
            viewmode: false,
            chargerId: "New"
        }
    },
    async mounted() {
        this.rightToUpdate = new AppUtils().getUserAccess("40|U");
        if (this.$route.params.chargerId) {
            if (this.$route.query.mode) {
                this.viewmode = false;
                this.chargerId = "Edit";
            } else {
                this.viewmode = true;
                this.chargerId = "Detail";
            }
        }
    },
    methods: {
        navigatePreviousPage() {
      this.$router.go(-1)
    },
        editCharger() {
            this.viewmode = false;
            this.chargerId = "Edit";
        }
    }
})
</script>
